// extracted by mini-css-extract-plugin
export default {"wrapper":"MiniSearchB2c_wrapper__GVmA1"};